// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { mapActions } from 'vuex'
import Container from './Container'
import router from './router'
import axios from 'axios'
import store from './store'
import mixins from './plugins/mixins'
import Vue2TouchEvents from 'vue2-touch-events'
import VueHead from 'vue-head'

Vue.config.productionTip = false

Vue.use(VueHead)
Vue.use(Vue2TouchEvents, {
  touchClass: 'tap',
  tapTolerance: 0,
})

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#container',
  router,
  components: { Container },
  mixins: [
    'getImage'
  ],
  template: '<Container/>',
  store,
  watch: {
    '$store.state.isSmartPhone': function () {
      this.getSpDir()
    }
  },
  methods: {
    ...mapActions(['isSmartPhone', 'getSpDir']),
  },
  mounted () {
    this.isSmartPhone()
    this.getSpDir()
  }
})



// WEBPACK FOOTER //
// ./src/main.js